import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,getKCISData} from '../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select ,Modal } from 'antd';
import { getToken} from "firebase/messaging";
import { messaging } from '../firebase';
import "../assets/css/app-css.css";

import DatePickers from "react-datepicker"; 
import {UserOutlined,EditOutlined} from '@ant-design/icons';
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;


function callback(key) {
  console.log(key);
}



function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			stduent_list: [],
			stduent_count: 0,
			stduent_load: true,
			teaching_staff: 0,
			non_teaching_staff: 0,
			all_teaching_staff: 0,
			staff_load: true,
			parent_open: 0,
			parent_process: 0,
			parent_closed: 0,
			staff_open: 0,
			staff_process: 0,
			staff_closed: 0,
			concern_load: true,
			concern_type: 'today',
			student_android: 0,
			student_ios: 0,
			student_web: 0,
			staff_android: 0,
			staff_ios: 0,
			staff_web: 0,
			student_never: 0,
			staff_never: 0,
			slot: 0,
			total_transport: 0,
			login_load: true,
			login_type: '1',
			attendance_list: [],
			attendance_load: true,
			enquiry_list: [],
			enquiry_load: true,
			enquiry_type: 'today',
			academic_year_: [],
			academic_year: '',
			att_academic_year: '',
			ts_academic_year: '',
			en_academic_year: '',
			email_template: [],
			template_details: [],
			email_load: [],
			visible: false,
			stduentadmin_load: false,
			total_student_count: 0,
			total_student_transport:0,
			total_student_daycare: 0,
			total_capacity: 0,
			admin_teaching_staff: 0,
			admin_non_teaching_staff: 0,
			admin_all_teaching_staff: 0,
			admin_staff_load: false,
			upcoming_bus_expiry: [],
			bus_expiry_load: false,
			expired_bus_list: [],
			permission: [],
			expired_bus_load: false,
		}
		this.change_year = this.change_year.bind(this);
		this.change_year_ts = this.change_year_ts.bind(this);
		this.change_att_year = this.change_att_year.bind(this);
		this.change_year_en = this.change_year_en.bind(this);
		this.change_frequency = this.change_frequency.bind(this);
		this.change_status = this.change_status.bind(this);
		this.handleTimeChange = this.handleTimeChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			 });
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				var new_id = erp_id.split('_');
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							localStorage.setItem("app_token",params.t);
							var erp_id = result['data'][0]['erp_id'];
							var erp_type = erp_id.split('_');
							localStorage.setItem("erp_id",erp_id);
							localStorage.setItem("erp_type",erp_type[0]);
							window.location.reload(false);
						}
					}
				});
			}
			
		}else{
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.t!=null && params.s!=null){
				var app_token = localStorage.getItem("app_token");
				var check_id = localStorage.getItem("erp_id");
				if(params.t != app_token || check_id!=params.s){
					let token = params.t;
					let erp_id = params.s;
					var app = {token:token,erp_id:erp_id}
					var new_id = erp_id.split('_');
					getKCISData('auth/verify_token',app).then((result) => {
						let responseJson = result;
						if(responseJson){
							if(result['status'] == 200){
								localStorage.setItem('schoolData',JSON.stringify(responseJson));
								localStorage.setItem("app_token",params.t);
								var erp_id = result['data'][0]['erp_id'];
								var erp_type = erp_id.split('_');
								localStorage.setItem("erp_id",erp_id);
								localStorage.setItem("erp_type",erp_type[0]);
								window.location.reload(false);
							}
						}
					});
				}
			}
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}
			getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
			});
			
			this.setState({ permission : storedArray['data'][0]['permission'],user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],type : storedArray['data'][0]['type']});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			var app_token = localStorage.getItem("app_token");
			var check_id = localStorage.getItem("erp_id");
			var main_link = 'https://erp.kidzonia.co.in/panel/admin';
			this.setState({ 
				academic_year : new_acad,
				att_academic_year : new_acad,
				ts_academic_year : new_acad,
				app_token : app_token,
				erp_id : check_id,
				main_link: main_link,
			});
			setTimeout(() => {
				this.requestForToken();
				this.checkData();
			}, 500);
		}
	}
	
	requestForToken = () => {
	  return getToken(messaging, { vapidKey: 'BGC9W3mZIhr8rp3r9JnyTnAtXoD1eNEODkaW8UJtBlhLIWyHDMkfbJ73sepGrMbdB8zzxWmEKsj3SD97R7LXcn0' })
		.then((currentToken) => {
		  if (currentToken) {
			this.updateToken(currentToken);

		  } else {
			// Show permission request UI
			console.log('No registration token available. Request permission to generate one.');
		  }
		}) 
		.catch((err) => {
		  console.log('An error occurred while retrieving token. ', err);
		});
	};
	
	updateToken = (token) => {
		var app = {user_id:this.state.user_id,fcmToken:token}
		getData('chat/update_school_fcm_token_web',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					
				}
			}
		});	
    }  
	
	checkData(){
		console.log('academic_year :',this.state.academic_year);
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var app = {user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id']}
		getData('common/get_academic_year',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						academic_year_: result['data'],
						current_year: result['current_year'],
						academic_year : result['current_year'],
						att_academic_year : result['current_year'],
						ts_academic_year : result['current_year'],
					});
					this.checkStudent();
					this.checkAminStudent();
					this.checkAminStaff();
					this.checkStaff();
					this.checkConcern();
					this.checkLogin();
					this.checkAttendance();
					this.checkEnquiry();
					this.checkEmail();
					this.checkTransportExpiry();
				}else{
					this.setState({
						academic_year_: [],
					});
				}
			}
		});	
		
	}
	
	checkAminStudent(){
		this.setState({stduentadmin_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,academic_year:this.state.ts_academic_year}
			getKCISData('dashboard/admin_stduent_list',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						total_student_count: result['student_count'],
						total_student_transport: result['student_transport'],
						total_student_daycare: result['student_daycare'],
						total_capacity: result['total_capacity'],
						stduentadmin_load: false,
					});
				}else{
					this.setState({
						total_student_count: 0,
						total_student_transport: 0,
						total_student_daycare: 0,
						total_capacity: 0,
						stduentadmin_load: false,
					});
				}
			});		
		}
	}
	
	checkAminStaff(){
		this.setState({staff_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getKCISData('dashboard/admin_staff_list',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						admin_teaching_staff: result['teaching_staff'],
						admin_non_teaching_staff: result['non_teaching_staff'],
						admin_all_teaching_staff: result['all_teaching_staff'],
						admin_staff_load: false,
					});
				}
			});		
		}
	}
	
	checkStudent(){
		this.setState({stduent_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,academic_year:this.state.academic_year}
			getData('dashboard/stduent_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							stduent_list: result['data'],
							stduent_count: result['total_count'],
							slot: result['slot'],
							total_transport: result['total_transport'],
							stduent_load: false,
						});
					}else{
						this.setState({
							stduent_list: [],
							stduent_count: 0,
							slot: 0,
							total_transport: 0,
							stduent_load: false,
						});
					}
				}
			});		
		}
	}
	
	checkStaff(){
		this.setState({staff_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('dashboard/staff_list',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						teaching_staff: result['teaching_staff'],
						non_teaching_staff: result['non_teaching_staff'],
						all_teaching_staff: result['all_teaching_staff'],
						staff_load: false,
					});
				}
			});		
		}
	}
	
	checkConcern(){
		this.setState({concern_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,concern_type:this.state.concern_type}
			getData('dashboard/concern_list',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						parent_open: result['parent_open'],
						parent_process: result['parent_process'],
						parent_closed: result['parent_closed'],
						staff_open: result['staff_open'],
						staff_process: result['staff_process'],
						staff_closed: result['staff_closed'],
						concern_load: false,
					});
				}
			});		
		}
	}
	
	checkLogin(){
		this.setState({login_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('dashboard/login_list',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						student_android: result['student_android'],
						student_ios: result['student_ios'],
						student_web: result['student_web'],
						staff_android: result['staff_android'],
						staff_ios: result['staff_ios'],
						staff_web: result['staff_web'],
						student_never: result['student_never'],
						staff_never: result['staff_never'],
						login_load: false,
					});
				}
			});		
		}
	}
	
	checkAttendance(){
		this.setState({attendance_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,academic_year:this.state.att_academic_year}
			getData('dashboard/attendance_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							attendance_list: result['data'],
							attendance_load: false,
						});
					}else{
						this.setState({
							attendance_list: [],
							attendance_load: false,
						});
					}
				}
			});		
		}
	}
	
	checkEnquiry(){
		this.setState({enquiry_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,enquiry_type:this.state.enquiry_type,academic_year:this.state.en_academic_year}
			getData('dashboard/enquiry_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							enquiry_list: result['data'],
							enquiry_load: false,
						});
					}else{
						this.setState({
							enquiry_list: [],
							enquiry_load: false,
						});
					}
				}
			});		
		}
	}
	
	checkEmail(){
		this.setState({email_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('dashboard/email_template',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							email_template: result['data'],
							email_load: false,
						});
					}else{
						this.setState({
							email_template: [],
							email_load: false,
						});
					}
				}
			});		
		}
	}
	
	checkTransportExpiry(){
		this.setState({email_load: true});
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,limit:5}
			getData('dashboard/upcoming_bus_expiry',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							upcoming_bus_expiry: result['data'],
							bus_expiry_load: false,
						});
					}else{
						this.setState({
							upcoming_bus_expiry: [],
							bus_expiry_load: false,
						});
					}
				}
			});		
			getData('dashboard/expired_bus_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							expired_bus_list: result['data'],
							expired_bus_load: false,
						});
					}else{
						this.setState({
							expired_bus_list: [],
							expired_bus_load: false,
						});
					}
				}
			});		
		}
	}
	
	
	showModal = (id) => {
		this.setState({
		  email_id:id,
		  visible: true,
		});
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var app = {school_id : school_id,user_id : user_id,id:id}
		getData('dashboard/email_template_details',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){
					this.setState({
						template_details: result['data'],
						template_email: result['data'][0]['email'],
						template_status: result['data'][0]['status'],
						template_time: result['data'][0]['time'],
						template_frequency: result['data'][0]['frequency'],
					});
				}else{
					this.setState({
						template_details: [],
						
					});
				}
			}
		});
	};
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				user_id: this.state.user_id,
				school_id: this.state.school_id,
				school_type : localStorage.getItem("erp_type"),
				id: this.state.email_id,
				email: this.state.template_email,
				status: this.state.template_status,
				time: this.state.template_time,
				frequency: this.state.template_frequency 
			}
			getData('dashboard/update_email_template',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Followup added',2);
					this.setState({ loading: false,visible: false,email_id:'', template_email : '',template_status:'',template_time:'',template_frequency:'' });
					this.checkEmail();
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	ModalCancel = e => {
		this.setState({
		  email_id:'',
		  visible: false,
		});
	};
	  
	
	changeConcern(type){
		this.setState({
			concern_type: type,
		});
		setTimeout(() => {
			this.checkConcern();
		}, 50);
	}
	
	changeEnquiry(type){
		this.setState({
			enquiry_type: type,
		});
		setTimeout(() => {
			this.checkEnquiry();
		}, 50);
	}
	
	changeLogin(type){
		this.setState({
			login_type: type,
		});
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	change_year(event){
		this.setState({academic_year: event.target.value});
		setTimeout(() => {
			this.checkStudent();
		}, 500);
	}
	
	change_year_ts(event){
		this.setState({ts_academic_year: event.target.value});
		setTimeout(() => {
			this.checkAminStudent();
		}, 500);
	}
	
	change_att_year(event){
		this.setState({att_academic_year: event.target.value});
		setTimeout(() => {
			this.checkAttendance();
		}, 500);
	}
	
	change_year_en(event){
		this.setState({en_academic_year: event.target.value});
		setTimeout(() => {
			this.checkEnquiry();
		}, 500);
	}
	
	change_frequency(event){
         this.setState({template_frequency: event});
    }
	
	change_status(event){
         this.setState({template_status: event});
    }
	
	handleTimeChange = (time, timeString) => {
		console.log('time :',timeString);
		this.setState({
			template_time: timeString
		});
	};
	
	render()

	{
		
		return (
			<div class="mobile_view home-dash">
				<div id="main" class="bg-off">
					<div class="row">
				 
					<div class={`col-sm-12  ${this.state.type == 'admin' ? 'col-xl-6':'col-xl-8'}`}>
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Student
									<span class="icon-count">
										<UserOutlined />{this.state.stduent_count}
									</span>
									<span class="capacity-count"> Capacity - {this.state.slot} </span>
									<span class="capacity-count "> <span class="mobile-hide">|</span> Transport Capacity - {this.state.total_transport} </span>
									<span class="school-div">
										<select  onChange={this.change_year} className="form-control changeSchool" value={this.state.academic_year}>
											{this.state.academic_year_.map((list) => (
												<option value={list.name}>{list.name}</option>
											))}
										</select>
									</span>
								</div>
								<div class="card-body">
									{(() => {
										if(this.state.stduent_load == true){
										  return (
											<>
												<h5 class="center">Please Wait While Loading !!</h5>
											</>
										  );
										}else if(this.state.stduent_list.length > 0){
										  return (
											<>
												{this.state.stduent_list.map((list) => (
												<div class="class-head"><div class="class-div"><b>{list.count}</b>{list.name}</div></div>
												))}
											</>
										  );
										}else{
											return (
											<>
												<h5 class="center">No Class Was Found !!</h5>
											</>
											);
										}
									})()}
									
									
									
								</div>
							</div>
						</a>
					</div>
					<div class={`col-sm-12 ${this.state.type == 'admin' ? 'col-xl-3':'col-xl-4'}`} >
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Staff
								</div>
								<div class="card-body">
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> Teaching Staff</b>{this.state.teaching_staff}</div></div>
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> Non Teaching Staff</b>{this.state.non_teaching_staff}</div></div>
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> All Staff</b>{this.state.all_teaching_staff}</div></div>
									
								</div>
							</div>
						</a>
					</div>
					
					
					{this.state.type == 'admin' ? 
					(<>
						<div class="col-sm-12 col-xl-3 ">
							<a href="javascript:void(0)" class="text-secondary">
								<div class="card">
									<div class="card-header">
										Total Student 
										<span class="school-div" style={{'width':'40%'}}>
											<select  onChange={this.change_year_ts} className="form-control changeSchool" value={this.state.ts_academic_year}>
												{this.state.academic_year_.map((list) => (
													<option value={list.name}>{list.name}</option>
												))}
											</select>
										</span>
									</div>
									
									<div class="card-body">
										<div class="staff-head"><div class="staff-div"><b><UserOutlined />  Total Capacity </b>{this.state.total_capacity}</div></div>
										<div class="staff-head"><div class="staff-div"><b><UserOutlined />  Student </b>{this.state.total_student_count}</div></div>
										<div class="staff-head"><div class="staff-div"><b><UserOutlined />  Daycare Student </b>{this.state.total_student_daycare}</div></div>
										<div class="staff-head"><div class="staff-div"><b><UserOutlined />  Transport Student</b>{this.state.total_student_transport}</div></div>
										
									</div>
								</div>
							</a>
						</div>
						<div class={`col-sm-12 col-xl-4`} >
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Total Staff
								</div>
								<div class="card-body">
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> Teaching Staff</b>{this.state.admin_teaching_staff}</div></div>
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> Non Teaching Staff</b>{this.state.admin_non_teaching_staff}</div></div>
									<div class="staff-head"><div class="staff-div"><b><UserOutlined /> All Staff</b>{this.state.admin_all_teaching_staff}</div></div>
									
								</div>
							</div>
						</a>
					</div>
					</>)
					:(<></>)}
					
					<div class={`col-sm-12 ${this.state.type == 'admin' ? 'col-xl-4':'col-xl-6'}`} >
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Concern
									<span class="concern-div">
										<div className={` ${this.state.concern_type == 'today'? 'active' : ''}`} onClick={this.changeConcern.bind(this,'today')}>Today</div>
										<div className={` ${this.state.concern_type == 'last_7'? 'active' : ''}`} onClick={this.changeConcern.bind(this,'last_7')}>Last 7 Days</div>
										<div className={` ${this.state.concern_type == 'last_30'? 'active' : ''}`} onClick={this.changeConcern.bind(this,'last_30')}>Last 30 Days</div>
									</span>
									
								</div>
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>#</td>
													<td>Open</td>
													<td>Process</td>
													<td>Closed</td>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td data-label="#">Parent Concerns</td>
													<td data-label="Open">{this.state.parent_open}</td>
													<td data-label="Process">{this.state.parent_process}</td>
													<td data-label="Closed">{this.state.parent_closed}</td>
												</tr>
												<tr>
													<td data-label="#">Staff Concerns</td>
													<td data-label="Open">{this.state.staff_open}</td>
													<td data-label="Process">{this.state.staff_process}</td>
													<td data-label="Closed">{this.state.staff_closed}</td>
												</tr>
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					<div class={`col-sm-12 ${this.state.type == 'admin' ? 'col-xl-4':'col-xl-6'}`} >
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Login 
									<span class="concern-div">
										<div className={` ${this.state.login_type == '1'? 'active' : ''}`} onClick={this.changeLogin.bind(this,'1')} >Login Status</div>
										<div className={` ${this.state.login_type == '0'? 'active' : ''}`} onClick={this.changeLogin.bind(this,'0')}>Never Logged in </div>
									</span>
									
								</div>
								<div class="card-body">
									<div class="table-new">
										{(() => {
										if(this.state.login_type == 1){
										  return (
											<>
												<table>
													<thead>
														<tr>
															<td>#</td>
															<td>Web</td>
															<td>Android</td>
															<td>IOS</td>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td data-label="#">Parent / Student</td>
															<td data-label="Web">{this.state.student_web}</td>
															<td data-label="Android">{this.state.student_android}</td>
															<td data-label="IOS">{this.state.student_ios}</td>
														</tr>
														<tr>
															<td data-label="#">Staff</td>
															<td data-label="Web">{this.state.staff_web}</td>
															<td data-label="Android">{this.state.staff_android}</td>
															<td data-label="IOS">{this.state.staff_ios}</td>
														</tr>
													</tbody>
												</table>
											</>
										  );
										}else{
											return (
											<>
												<table>
													<thead>
														<tr>
															<td>#</td>
															<td>Count</td>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td data-label="#">Parent / Student</td>
															<td data-label="Count">{this.state.student_never}</td>
														</tr>
														<tr>
															<td data-label="#">Staff</td>
															<td data-label="Count">{this.state.staff_never}</td>
														</tr>
													</tbody>
												</table>
											</>
											);
										}
									})()}
										
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					
					
					<div class="col-sm-12 col-xl-5">
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Student Attendance 
									<span class="school-div hide">
										<select  onChange={this.change_att_year} className="form-control changeSchool" value={this.state.att_academic_year}>
											{this.state.academic_year_.map((list) => (
												<option value={list.name}>{list.name}</option>
											))}
										</select>
									</span>
									
								</div>
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>#</td>
													<td>Total<br/> Student</td>
													<td>Present</td>
													<td>Half<br/> Day</td>
													<td>Absent</td>
													<td>Leave</td>
												</tr>
											</thead>
											<tbody>
												{(() => {
												if(this.state.attendance_load == true){
												  return (
													<>
													<tr>
														<td colspan="6" class="center">Please Wait While Loading !!</td>
													</tr>	
													</>
												  );
												}else if(this.state.attendance_list.length > 0){
												  return (
													<>
														{this.state.attendance_list.map((list) => (
														<tr>
															<td data-label="Count">{list.name}</td>
															<td data-label="Total Student">{list.student_count}</td>
															<td data-label="Present">{list.student_in}</td>
															<td data-label="Halfday">{list.student_halfday}</td>
															<td data-label="Absent">{list.student_absent}</td>
															<td data-label="Leave">{list.student_leave}</td>
														</tr>
														))}
													</>
												  );
												}else{
													return (
													<>	
													<tr>
														<td colspan="6" class="center">No Class Was Found !!</td>
													</tr>	
													</>
													);
												}
											})()}
												
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					<div class="col-sm-12 col-xl-7">
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Enquiry
									<span class="concern-div right">
										<div className={` active`} ><a href={`${this.state.main_link}/enquiry-list?t=${this.state.aToken}&s=${this.state.erp_id}`} >View All</a></div>
									</span>
									<span class="concern-div">
										<div className={` ${this.state.enquiry_type == 'today'? 'active' : ''}`} onClick={this.changeEnquiry.bind(this,'today')}>Today</div>
										<div className={` ${this.state.enquiry_type == 'last_7'? 'active' : ''}`} onClick={this.changeEnquiry.bind(this,'last_7')}>Last 7 Days</div>
										<div className={` ${this.state.enquiry_type == 'last_30'? 'active' : ''}`} onClick={this.changeEnquiry.bind(this,'last_30')}>Last 30 Days</div>
										<div className={` ${this.state.enquiry_type == 'all'? 'active' : ''}`} onClick={this.changeEnquiry.bind(this,'all')}>All</div>
									</span>
									{this.state.enquiry_type == 'all'? (<>
										<span class="school-div">
											<select  onChange={this.change_year_en} className="form-control changeSchool" value={this.state.en_academic_year}>
												{this.state.academic_year_.map((list) => (
													<option value={list.name}>{list.name}</option>
												))}
											</select>
										</span>
									</>) : (<></>)}
									
								</div>
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>#</td>
													<td>Ext. Enquiry</td>
													<td>Int. Enquiry</td>
													<td>Ext. Admission</td>
													<td>Int. Admission</td>
													<td>Conversion</td>
													<td>Open</td>
													<td>Potential</td>
													<td>Lost</td>
													<td>Followup</td>
												</tr>
											</thead>
											<tbody>
												{(() => {
												if(this.state.enquiry_load == true){
												  return (
													<>
													<tr>
														<td colspan="12" class="center">Please Wait While Loading !!</td>
													</tr>	
													</>
												  );
												}else if(this.state.enquiry_list.length > 0){
												  return (
													<>
														{this.state.enquiry_list.map((list) => (
														<tr>
															<td data-label="#">{list.name}</td>
															<td data-label="Ext. Enquiry">{list.enquiry}</td>
															<td data-label="Int. Enquiry">{list.int_enquiry}</td>
															<td data-label="Ext. Admission">{list.enquiry_enroll}</td>
															<td data-label="Int. Admission">{list.enquiry_enroll_1}</td>
															<td data-label="Conversion">{list.conversion}</td>
															<td data-label="Open">{list.open}</td>
															<td data-label="Potential">{list.potential}</td>
															<td data-label="Lost">{list.lost}</td>
															<td data-label="Followup">{list.enquiry_today}</td>
														</tr>
														))}
													</>
												  );
												}else{
													return (
													<>	
													<tr>
														<td colspan="12" class="center">No Enquiry Was Found !!</td>
													</tr>	
													</>
													);
												}
											})()}
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					{(() => {
					if (this.state.type == 'admin' || this.state.type == 'school' || this.state.permission.find(element => element == 15)) {
					return (
					<>
					
					<div class="col-sm-12 col-xl-6">
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Upcoming Bus Document Expiry
									<span class="concern-div right">
										<div className={` active`} ><a href={`${process.env.PUBLIC_URL}/upcoming-bus-expiry`} >View All</a></div>
									</span>
								</div>
								
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>Bus Name / No</td>
													<td>Document Name</td>
													<td>Expiry Date</td>
												</tr>
											</thead>
											<tbody>
												{(() => {
												if(this.state.bus_expiry_load == true){
												  return (
													<>
													<tr>
														<td colspan="6" class="center">Please Wait While Loading !!</td>
													</tr>	
													</>
												  );
												}else if(this.state.upcoming_bus_expiry.length > 0){
												  return (
													<>
														{this.state.upcoming_bus_expiry.map((list) => (
														<tr>
															<td data-label="Bus Name / No">{list.bus_name} - {list.bus_no}</td>
															<td data-label="Document Name">{list.doc_name}</td>
															<td data-label="Expiry Date">{list.expiry_date}</td>
														</tr>
														))}
													</>
												  );
												}else{
													return (
													<>	
													<tr>
														<td colspan="6" class="center">No Document Was Found !!</td>
													</tr>	
													</>
													);
												}
											})()}
												
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					<div class="col-sm-12 col-xl-6">
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Expired Bus Document 
									<span class="concern-div right">
										<div className={` active`} ><a href={`${process.env.PUBLIC_URL}/expired-bus-list`} >View All</a></div>
									</span>
								</div>
								
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>Bus Name / No</td>
													<td>Document Name</td>
													<td>Expiry Date</td>
												</tr>
											</thead>
											<tbody>
												{(() => {
												if(this.state.expired_bus_load == true){
												  return (
													<>
													<tr>
														<td colspan="6" class="center">Please Wait While Loading !!</td>
													</tr>	
													</>
												  );
												}else if(this.state.expired_bus_list.length > 0){
												  return (
													<>
														{this.state.expired_bus_list.map((list) => (
														<tr>
															<td data-label="Bus Name / No">{list.bus_name} - {list.bus_no}</td>
															<td data-label="Document Name">{list.doc_name}</td>
															<td data-label="Expiry Date">{list.expiry_date}</td>
														</tr>
														))}
													</>
												  );
												}else{
													return (
													<>	
													<tr>
														<td colspan="6" class="center">No Document Was Found !!</td>
													</tr>	
													</>
													);
												}
											})()}
												
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					
					</>	
					)
					}
					})()}
					
					{(() => {
					if (this.state.type == 'admin' || this.state.type == 'school') {
					return (
					<>
					<div class="col-sm-12 col-xl-12 hidden">
						<a href="javascript:void(0)" class="text-secondary">
							<div class="card">
								<div class="card-header">
									Automated Email Alerts 
									<span class="school-div hide">
										<select  onChange={this.change_att_year} className="form-control changeSchool" value={this.state.att_academic_year}>
											{this.state.academic_year_.map((list) => (
												<option value={list.name}>{list.name}</option>
											))}
										</select>
									</span>
									
								</div>
								<div class="card-body">
									<div class="table-new">
										<table>
											<thead>
												<tr>
													<td>Job Name</td>
													<td>Email</td>
													<td>Schedule Frequency</td>
													<td>Schedule Time At</td>
													<td>Status</td>
													<td>Action</td>
												</tr>
											</thead>
											<tbody>
												{(() => {
												if(this.state.email_load == true){
												  return (
													<>
													<tr>
														<td colspan="6" class="center">Please Wait While Loading !!</td>
													</tr>	
													</>
												  );
												}else if(this.state.email_template.length > 0){
												  return (
													<>
														{this.state.email_template.map((list) => (
														<tr>
															<td data-label="Job Name">{list.name}</td>
															<td data-label="Email">{list.email}</td>
															<td data-label="Schedule Frequency">{list.frequency}</td>
															<td data-label="Schedule Time At">{list.time}</td>
															<td data-label="Status"><>
															{(() => {
																	if (list.status=='1') {
																		return (
																			<>
																				<div class="chip chip-green">
																					<div class="chip-body">
																						<span class="chip-text">Active</span>
																					</div>
																				</div>
																			</>
																		)
																	}
																	else{
																		return (
																			<>
																				<div class="chip chip-red">
																					<div class="chip-body">
																						<span class="chip-text">Inactive</span>
																					</div>
																				</div>
																			</>
																		)
																	}
																	
																})()}
														</></td>
															<td data-label="Action"><a href="javascript:void(0)" class="dropdown-item" onClick={this.showModal.bind(this,list.id)} ><EditOutlined /> Edit</a></td>
														</tr>
														))}
													</>
												  );
												}else{
													return (
													<>	
													<tr>
														<td colspan="6" class="center">No Email Was Found !!</td>
													</tr>	
													</>
													);
												}
											})()}
												
											</tbody>
										</table>
										
									</div>
									
								</div>
							</div>
						</a>
					</div>
					</>	
					)
					}
					})()}
				 
					
					<Modal
				 title="Email Alert"
				 visible={this.state.visible}
				 className="followup-model email-model"
				 onCancel={this.ModalCancel}
				>
					<>
					{this.state.template_details.map((item) => (
					<div class="row mt-10">
					<div class="col col-md-12 s12 form-group mb-0" >
						<input type="hidden" class="form-control" name="email_id" id="email_id" value={this.state.email_id}/>
						<label>Job Name : <b>{item.name} </b></label>
					</div>
					<div class="col col-md-12 s12 form-group mb-0">
						<label>Email</label>
						<TextArea
							placeholder="Your Text Goes Here !!"
							class="form-control"
							autoSize={{ minRows: 2, maxRows: 2 }}
							className=""
							onChange={this.handleSizeChange}
							name="template_email"
							value={this.state.template_email}
						/>
					</div>	
					
					<div class="col m4 s12 mt-10 form-group mb-0">
						<label>Schedule Frequency </label>
						<Select onChange={this.change_frequency} value={this.state.template_frequency}>
							<Select.Option value="">Select Frequency</Select.Option>
							<Select.Option value="Daily">Daily</Select.Option>
							<Select.Option value="Weekly">Weekly </Select.Option>
							<Select.Option value="Monthly">Monthly</Select.Option>
							<Select.Option value="Yealry">Yealry</Select.Option>
						</Select>
					</div>
					<div class="col m4 s12 mt-10 datetime_picker form-group mb-0">
						<label>Schedule Time At</label>
						{this.state.template_time!='' ? (<>
							<TimePicker
								use12Hours format="h:mm a"
								defaultValue={moment(this.state.template_time,'h:mm a')}
								onChange={this.handleTimeChange}
							/>
						</>) : (<>
							<TimePicker
								use12Hours format="h:mm a"
								onChange={this.handleTimeChange}
							/>
						</>)}
						
					</div>
					<div class="col m4 s12 mt-10 form-group mb-0">
						<label>Status </label>
						<Select onChange={this.change_status} value={this.state.template_status}>
							<Select.Option value="1">Active</Select.Option>
							<Select.Option value="0">Inactive </Select.Option>
						</Select>
					</div>
					
					<div class="col col-md-12 s12 text-center mt-20">
						<Button className="btn btn-primary" onClick={this.handleSubmit} loading={this.state.loading}>Update</Button>
					</div>
					</div>
					))}
					
					</>
				</Modal>	
				
				
					</div>
				</div>
			</div>
		) 
	} 
}
export default Index;
